/**
 * Analytics & Event Tracker Utility
 * Handles GA4 event dispatching, user interaction logging, and conversion tracking.
 */

// Initialize Google Analytics GA4 script dynamically if MEASUREMENT_ID is configured
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-VISTAHAND01';

export function initAnalytics() {
  if (typeof window === 'undefined' || window.gtag) return;

  // Insert GA script into head
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };

  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: window.location.pathname
  });
}

/**
 * Tracks custom user actions & conversion events.
 * @param {string} eventName - Name of the event (e.g., 'lead_submission', 'msp_calculator_used')
 * @param {Object} eventParams - Context parameters (e.g. service, plan, estimatedPrice)
 */
export function trackEvent(eventName, eventParams = {}) {
  if (process.env.NODE_ENV !== 'production') {
    console.log(`[Analytics Event]: ${eventName}`, eventParams);
  }

  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
}

/**
 * Convenience helper for MSP Calculator usage events
 */
export function trackMspCalculator(users, servers, compliance, helpdesk, estimatedPrice) {
  trackEvent('msp_calculator_used', {
    users_count: users,
    servers_count: servers,
    compliance_tier: compliance,
    helpdesk_coverage: helpdesk,
    estimated_monthly_price: estimatedPrice
  });
}

/**
 * Convenience helper for Lead Submissions
 */
export function trackLeadSubmission(serviceName, status) {
  trackEvent('lead_form_submitted', {
    service_name: serviceName,
    status: status
  });
}
